import { AlertTriangle, Flame, Info, Minus } from 'lucide-react';
import { POST_CATEGORY_LABELS, type PostAnalysisDTO, type PostCategory } from '@bb/shared';
import { cn } from '@/lib/cn';

const STYLE: Record<PostCategory, { className: string; icon: typeof Info }> = {
  ANECDOTAL: { className: 'border-line-bright text-ink-faint', icon: Minus },
  INFORMATION: { className: 'border-info/40 bg-info-dim text-info', icon: Info },
  DRAMA: { className: 'border-amber/50 bg-amber-dim text-amber', icon: Flame },
  EMERGENCY: { className: 'border-alert/60 bg-alert-dim text-alert', icon: AlertTriangle },
};

export function CategoryBadge({
  analysis,
  className,
}: {
  analysis: PostAnalysisDTO;
  className?: string;
}) {
  const { className: tone, icon: Icon } = STYLE[analysis.category];

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-sharp border px-1.5 py-px font-mono text-[10px] font-medium uppercase tracking-[0.1em]',
        tone,
        className,
      )}
      title={analysis.reasoning ?? undefined}
    >
      <Icon size={10} strokeWidth={2} />
      {POST_CATEGORY_LABELS[analysis.category]}
      {/* The score only carries meaning inside its category, so it rides along
          with the label rather than standing alone anywhere. */}
      <span className="text-[9px] opacity-70">{analysis.importance}</span>
    </span>
  );
}

/** Shown while the classifier has not reached the post yet. */
export function PendingBadge() {
  return (
    <span className="inline-flex items-center gap-1 rounded-sharp border border-line px-1.5 py-px font-mono text-[10px] uppercase tracking-[0.1em] text-ink-faint">
      <span className="size-1 animate-pulse rounded-full bg-ink-faint" />
      Triage
    </span>
  );
}
